import { Role as a } from "./role.js";
var e = /* @__PURE__ */ ((t) => (t.GOOGLE = "google", t.APPLE = "appleweb", t.DISCORD = "discord", t.TWITTER = "twitter", t.SKY_MAVIS = "skymavis", t.Unspecified = "unspecified", t))(e || {}), n = /* @__PURE__ */ ((t) => (t.Login = "login", t.LinkApp = "linkApp", t))(n || {});
const l = {
  avatar: "https://nftprops-staging.apeironnft.com/marketplace/accountartworks/player_avatar.png",
  createdAt: "",
  invitation: {
    believerCount: 0,
    code: "",
    inviter: ""
  },
  name: "",
  tag: 0,
  walletAddress: ""
}, c = {
  accessToken: "",
  email: "",
  id: "",
  new: !1,
  notification: {
    assetSold: !1,
    gameUpdate: !1,
    marketingEvent: !1
  },
  refreshToken: "",
  role: a.Guest,
  chainType: null,
  ...l
}, s = {
  balances: {},
  walletDisplayMode: !1,
  ...c
};
export {
  c as EmptyAccount,
  s as EmptyFullAccount,
  l as EmptyPublicAccount,
  e as SsoProviderType,
  n as SsoPurpose
};
//# sourceMappingURL=account.js.map
